import FullPageSpinner from './FullPageSpinner';
export default FullPageSpinner;